/**
 * Stable error codes of the "Acceso MCP" provisioning flow (BR-MCP-01
 * through BR-MCP-09). Thrown by the backend as `CODE: technical detail`
 * (sanitized — see `sanitizeAuth0Error`, `apps/niko-backend-api/src/app/
 * auth0/utils/sanitize-auth0-error.ts`) and mapped by the frontend to a
 * translated message via `MCP_ACCESS_ERROR_I18N`, the same error-code →
 * i18n pattern already established by `PROSPECT_ERROR_I18N` and
 * `IMPERSONATION_ERROR_I18N`. Self-contained — no imports — because it is
 * reached from Angular via `@niko-crm/core/constants`.
 */
export const MCP_ACCESS_ERROR_CODE = {
  AUTH0_NOT_CONFIGURED: 'MCP_ACCESS_AUTH0_NOT_CONFIGURED',
  USER_ALREADY_EXISTS: 'MCP_ACCESS_USER_ALREADY_EXISTS',
  TENANT_SLUG_MISSING: 'MCP_ACCESS_TENANT_SLUG_MISSING',
  AUTH0_AUTH_FAILED: 'MCP_ACCESS_AUTH0_AUTH_FAILED',
  AUTH0_SCOPE_DENIED: 'MCP_ACCESS_AUTH0_SCOPE_DENIED',
  AUTH0_RATE_LIMITED: 'MCP_ACCESS_AUTH0_RATE_LIMITED',
  AUTH0_UNAVAILABLE: 'MCP_ACCESS_AUTH0_UNAVAILABLE',
  PERMISSION_GRANT_FAILED: 'MCP_ACCESS_PERMISSION_GRANT_FAILED',
  METADATA_UPDATE_FAILED: 'MCP_ACCESS_METADATA_UPDATE_FAILED',
  INVITATION_FAILED: 'MCP_ACCESS_INVITATION_FAILED',
  ALREADY_REVOKED: 'MCP_ACCESS_ALREADY_REVOKED',
  ALREADY_ACTIVE: 'MCP_ACCESS_ALREADY_ACTIVE',
  IDENTITY_NOT_FOUND: 'MCP_ACCESS_IDENTITY_NOT_FOUND',
} as const;

export type McpAccessErrorCode =
  (typeof MCP_ACCESS_ERROR_CODE)[keyof typeof MCP_ACCESS_ERROR_CODE];

export const MCP_ACCESS_ERROR_I18N: Record<McpAccessErrorCode, string> = {
  [MCP_ACCESS_ERROR_CODE.AUTH0_NOT_CONFIGURED]: 'errors.mcpAccessAuth0NotConfigured',
  [MCP_ACCESS_ERROR_CODE.USER_ALREADY_EXISTS]: 'errors.mcpAccessUserAlreadyExists',
  [MCP_ACCESS_ERROR_CODE.TENANT_SLUG_MISSING]: 'errors.mcpAccessTenantSlugMissing',
  [MCP_ACCESS_ERROR_CODE.AUTH0_AUTH_FAILED]: 'errors.mcpAccessAuth0AuthFailed',
  [MCP_ACCESS_ERROR_CODE.AUTH0_SCOPE_DENIED]: 'errors.mcpAccessAuth0ScopeDenied',
  [MCP_ACCESS_ERROR_CODE.AUTH0_RATE_LIMITED]: 'errors.mcpAccessAuth0RateLimited',
  [MCP_ACCESS_ERROR_CODE.AUTH0_UNAVAILABLE]: 'errors.mcpAccessAuth0Unavailable',
  [MCP_ACCESS_ERROR_CODE.PERMISSION_GRANT_FAILED]: 'errors.mcpAccessPermissionGrantFailed',
  [MCP_ACCESS_ERROR_CODE.METADATA_UPDATE_FAILED]: 'errors.mcpAccessMetadataUpdateFailed',
  [MCP_ACCESS_ERROR_CODE.INVITATION_FAILED]: 'errors.mcpAccessInvitationFailed',
  [MCP_ACCESS_ERROR_CODE.ALREADY_REVOKED]: 'errors.mcpAccessAlreadyRevoked',
  [MCP_ACCESS_ERROR_CODE.ALREADY_ACTIVE]: 'errors.mcpAccessAlreadyActive',
  [MCP_ACCESS_ERROR_CODE.IDENTITY_NOT_FOUND]: 'errors.mcpAccessIdentityNotFound',
};
